import React from 'react';
import { StyledButtonPrimaryProps, StyledCaptionSpan } from './Button.primary.styles';
import { StyledButtonPro } from 'elements/buttons/Button.pro.styles';

interface ButtonProProps extends StyledButtonPrimaryProps {
  onClick: () => void;
  text: string;
  type?: 'button' | 'submit'
  caption?: string;
}

const ButtonPro = ({ onClick, text, type = 'button', caption, justify, weight }: ButtonProProps): JSX.Element => {
  return (
    <StyledButtonPro type={type} onClick={onClick} justify={justify} weight={weight}>
      <span>
        {text}
      </span>
      {
        caption ?
          <StyledCaptionSpan>
            {caption}
          </StyledCaptionSpan>
          : null
      }
    </StyledButtonPro>
  )
}

export default ButtonPro;
